"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const useAnimateInOut_1 = require("../../../hooks/useAnimateInOut");
const icons_1 = require("../../../icons/icons");
const useMaxHeight_1 = require("../../../hooks/useMaxHeight");
const Accordion = ({ title, initialState, children, className, testing }) => {
    const { display, animateIn, toggle, status } = (0, useAnimateInOut_1.useAnimateInOut)(initialState);
    const contentsRef = (0, react_1.useRef)(null);
    const contentsMaxHeight = (0, useMaxHeight_1.useMaxHeight)(contentsRef, animateIn);
    const detailsToggleHandler = (e) => {
        e.preventDefault();
        toggle();
    };
    return (react_1.default.createElement("details", { open: display, onToggle: (e) => e.preventDefault(), className: (0, classnames_1.default)('rounded border border-slate-3', className) },
        react_1.default.createElement("summary", { className: "flex w-full cursor-pointer items-center justify-between rounded px-4 py-6 focus:outline-none focus:ring focus:ring-blue-4/20", onClick: detailsToggleHandler },
            react_1.default.createElement("div", { className: "text-lg font-bold text-blue-5" }, title),
            react_1.default.createElement("div", { className: (0, classnames_1.default)('select-none text-blue-5 transition-transform', { 'rotate-180': status }) }, icons_1.SVG_ARROW_DOWN)),
        react_1.default.createElement("div", { ref: contentsRef, className: "overflow-hidden", style: {
                transition: 'max-height 150ms ease-in-out',
                maxHeight: contentsMaxHeight,
            }, "data-testid": testing && 'accordion-container' },
            react_1.default.createElement("div", { className: "px-4 py-4" }, children))));
};
exports.Accordion = Accordion;
